
export type PrefabModelType = typeof PrefabModelType[keyof typeof PrefabModelType];


export const PrefabModelType = {
  Representation: 'Representation',
  SubPart: 'SubPart',
  Group: 'Group',
} as const;
